import React from "react";
import { Box, Typography } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import { FileInfo } from "./DetailsTab/FileInfo";
import { DocumentInfoCard } from "./DetailsTab/DocumentInfoCard";
import { ProcessingInfo } from "./DetailsTab/ProcessingInfo";
import { MetadataCard } from "./DetailsTab/MetadataCard";
import { DocumentCategoryCard } from "./DetailsTab/DocumentCategoryCard";
import { ParentChildInfoCard } from "./DetailsTab/ParentChildInfoCard"; // Added import

interface DetailsTabProps {
  document: StratifyDocument;
}

export const DetailsTab: React.FC<DetailsTabProps> = ({ document }) => {
  return (
    <Typography variant="body2">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 4 }}>
        <DocumentCategoryCard document={document} />
        <DocumentInfoCard document={document} />
        <ParentChildInfoCard document={document} /> {/* Added card */}
        <FileInfo document={document} />
        <ProcessingInfo document={document} />
        {document.metadata?.processing?.result?.metadata && (
          <MetadataCard document={document} />
        )}
      </Box>
    </Typography>
  );
};
